export default "__VITE_ASSET__CPJINpLf__"